import React, { useState } from 'react';
import { FormGroup, Label } from 'reactstrap';
import ColorPickerModal from './ColorPickerModal';

const ColorConfigItem = ({ label, value, onChange }) => {
  const [showColorPicker, setShowColorPicker] = useState(false);

  return (
    <FormGroup className="mb-2" style={{minWidth: 120, maxWidth: 220, display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'flex-end'}}>
      {label && <Label style={{marginBottom: 0, minWidth: 80, fontWeight: 500, flexGrow: 1, textAlign: 'left'}}>{label}</Label>}
      <div 
        onClick={() => setShowColorPicker(true)}
        style={{
          width: 80,
          height: 45,
          borderRadius: 6,
          border: '1.5px solid #bbb',
          backgroundColor: value,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginRight: 0,
          marginLeft: 8,
          boxShadow: '0 1px 4px #0001',
          fontFamily: 'monospace',
          fontSize: 13,
          color: getContrastYIQ(value),
          fontWeight: 600,
          letterSpacing: 0.5,
          transition: 'border 0.15s',
        }}
        title={value}
      >
        {value}
      </div>
      <ColorPickerModal
        isOpen={showColorPicker}
        toggle={() => setShowColorPicker(false)}
        value={value}
        onChange={onChange}
        label={label}
      />
    </FormGroup>
  );
};

export default ColorConfigItem;

// Helper function để chọn màu chữ cho dễ đọc
function getContrastYIQ(hexcolor) {
  let hex = hexcolor.replace('#', '');
  if (hex.length === 3) hex = hex.split('').map(x => x + x).join('');
  const r = parseInt(hex.substr(0,2),16);
  const g = parseInt(hex.substr(2,2),16);
  const b = parseInt(hex.substr(4,2),16);
  const yiq = ((r*299)+(g*587)+(b*114))/1000;
  return (yiq >= 160) ? '#222' : '#fff';
} 